<!-- Simple adapter: renders a Bootstrap Icons class by name. -->
<i [class]="'bi bi-' + name + (size === 'sm' ? ' fs-6' : size === 'lg' ? ' fs-3' : ' fs-5')" aria-hidden="true"></i>
